var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalimagenusuario80X80(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#80CFBC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0001 21.6668C43.9888 21.6668 47.2223 24.9003 47.2223 28.8891C47.2223 32.8778 43.9888 36.1113 40.0001 36.1113C36.0113 36.1113 32.7778 32.8778 32.7778 28.8891C32.7778 24.9003 36.0113 21.6668 40.0001 21.6668ZM50.5556 28.8891C50.5556 23.0594 45.8297 18.3335 40.0001 18.3335C34.1704 18.3335 29.4445 23.0594 29.4445 28.8891C29.4445 34.7187 34.1704 39.4446 40.0001 39.4446C45.8297 39.4446 50.5556 34.7187 50.5556 28.8891Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9926 48.2752C44.2375 45.5055 35.7627 45.5055 28.0075 48.2752C26.8703 48.6814 26.1112 49.7585 26.1112 50.9661V53.8894C26.1112 55.514 27.55 56.7618 29.1581 56.5321L31.2791 56.2291C37.0637 55.4027 42.9364 55.4027 48.721 56.2291L50.842 56.5321C52.4501 56.7618 53.8889 55.5139 53.8889 53.8894V50.9661C53.8889 49.7585 53.1298 48.6814 51.9926 48.2752ZM26.8864 45.1361C35.3665 42.1074 44.6336 42.1074 53.1137 45.1361C55.5776 46.016 57.2223 48.3498 57.2223 50.9661V53.8894C57.2223 57.5424 53.9868 60.3485 50.3706 59.8319L48.2496 59.5289C42.7777 58.7472 37.2224 58.7472 31.7505 59.5289L29.6295 59.8319C26.0133 60.3485 22.7778 57.5424 22.7778 53.8894V50.9661C22.7778 48.3498 24.4225 46.016 26.8864 45.1361Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "#80CFBC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalimagenusuario80X80);
export default __webpack_public_path__ + "static/media/MODAL IMAGEN USUARIO_80X80.c1bb1244ba5bca181963ef9037b485f3.svg";
export { ForwardRef as ReactComponent };